import numeral from "numeral";
import React, { useMemo } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";

const OriginalScopeProject = () => {
  const { project } = useSelector((state) => ({
    project: state.certifyReducer.project.data,
  }));

  const { originalCost, originalCeiling, projectScope } = useMemo(() => {
    const originalApplication = project?.project_profile_stages?.find(
      (obj) => obj?.status === 2 && obj?.stages === 4,
    );
    const scope = originalApplication?.original_project_scope || [];

    const cost = scope?.reduce(
      (acc, obj) => acc + (parseFloat(obj.cost_required) || 0),
      0,
    );

    const ceiling = scope.reduce(
      (acc, obj) => acc + (parseFloat(obj.ceiling) || 0),
      0,
    );

    return {
      originalCost: cost,
      originalCeiling: ceiling,
      projectScope: scope,
    };
  }, [project]);

  return (
    <div className='mb-3'>
      <div className='mb-3'>
        <h5>SENARAI ASAL SKOP PROJEK YANG DIPOHON</h5>
      </div>
      <div className='table-responsive'>
        <Table bordered size='sm' style={{ fontSize: 11, width: "100%" }}>
          <thead className='text-center align-middle custom-table-head'>
            <tr>
              <th style={{ width: "3%" }}>BIL.</th>
              <th>KOMPONEN PROJEK</th>
              <th>KOS DIPOHON (RM)</th>
              <th>SILING DIPOHON (RM)</th>
            </tr>
          </thead>
          <tbody className='text-uppercase' style={{ fontWeight: 500 }}>
            {projectScope?.map((obj, idx) => {
              return (
                <tr key={obj.id}>
                  <td className='text-center'>{idx + 1}.</td>
                  <td>{obj.cost_description}</td>
                  <td className='text-end pe-2'>
                    {numeral(obj.cost_required).format("0,0.00")}
                  </td>
                  <td className='text-end pe-2'>
                    {numeral(obj.ceiling).format("0,0.00")}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td colSpan={2} className='text-end pe-2'>
                JUMLAH
              </td>
              <td className='text-end pe-2'>
                {numeral(originalCost).format("0,0.00")}
              </td>
              <td className='text-end pe-2'>
                {numeral(originalCeiling).format("0,0.00")}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default OriginalScopeProject;
